// extracted by mini-css-extract-plugin
export var content = "_pm-1";
export var fullScreen = "_pm-0";